// $(function(){

//   $('[data-toggle="tooltip"]').tooltip();

//   $('.text-toggle').collapser({
// 		mode: 'chars',
//     truncate: 250,
//     ellipsis: '...',
//     showText: '',
// 	  hideText: '',
//     controlBtn: 'collapser_btn'
//   });

//   $('.btn-reset').click(function(){
//     $("#filterForm input[type='checkbox']").prop('checked',false);
//     $('.list-group-label__input').trigger('change');
//   });

//   $('.wrap-catalog-items-filtering__mobile-btn-open-filtering').on('click',function(){
//     $('#filterForm').slideToggle();
//   });

//   $('.wrap-catalog-items-content__btn-more').on('click', function(){
//     $(this).closest('.wrap-catalog-items-content__description').find('.collapser_btn').trigger('click');
//   });

//   var slider = $('#slider').slider({
//     handle: 'square',
//     tooltip: 'always',
//     tooltip_split: 'true',
//     tooltip_position: 'bottom',
//     reversed: true
//   });

//   var updateCartDebounce = debounce(function() {
//     $("#filterForm").submit();
//   }
//   , 1000);

//   $("body").on("change",".list-group-label__input",function(){
//     var em = $(this);
//     if(em.data("type") == "single"){
//       $("input[name='"+em.attr("name")+"']").each(function(){
//         if($(this).attr("value") != em.attr("value")){
//           $(this).prop('checked', false);
//         }
//       });
//     }
//     $(".wrap-category--loader").fadeIn();
//     updateCartDebounce();
//   });

//   $("body").on("change",".catalog-price-range",function(){
//     $(".wrap-category--loader").fadeIn();
//     updateCartDebounce();
//   });


//   var url = "";
//   var orgSrc = "";
//   $("#filterForm").on("submit",function(){
//     url = $(this).serialize();
//     orgSrc = $(this).attr('action');
//     $.get( orgSrc,$(this).serializeArray())
//     .done(function( data ) {
//       $(".wrap-category--items").html($(data).find(".wrap-category--items"));
//       history.pushState('', '', (orgSrc.includes('index.php') ? orgSrc + '&' : '?' ) + url);
//       $(".wrap-category--loader").fadeOut();
//       slider.slider('setAttribute',"min",$(data).find("#slider").data("slider-min"));
//       slider.slider('setAttribute',"max",$(data).find("#slider").data("slider-max"));
//       slider.slider('setAttribute',"value",$(data).find("#slider").data("slider-value"));
//       slider.slider('refresh');
//       $('.lazy').Lazy({
//         effect: "fadeIn",
//         effectTime: 1000,
//         threshold: 0
//       });
//       return false;
//     }, this);
//     return false;
//   });

//   $('.btn-reset-selection').click(function(){
//     $('.comparison-checkbox').prop('checked',false);
//     $.get("index.php?dir=site&page=compare&op=reset");
//   });

// });
